import React, { useContext, useState } from "react";

import { LockOutlined, LoginOutlined, MailOutline, PasswordOutlined,Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, Button, TextField,InputAdornment,IconButton } from "@mui/material";
import { Link } from "react-router-dom";
import { noauthinstance, updateToken } from '../../utils/api';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { AppContext } from "../../App";
function Login() {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [loading, setLoading] = useState(false);
	const [formSubmitted, setFormSubmitted] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const navigate = useNavigate()

	const { state, actions } = useContext(AppContext)

	const Spinner = () => (
		<div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 1000 }}>
			<div style={{ width: '30px', height: '30px', borderRadius: '50%', border: '4px solid #ccc', borderTop: '4px solid rgb(255 122 0)', animation: 'spin 1s linear infinite' }}></div>
		</div>
	);


	const handleLogin = async () => {
		setFormSubmitted(true);
		if (!email || !password) {
			toast.error("Please enter both email and password.");
			return;
		}
		const formdata = {
			email,
			password,
		};
		setLoading(true);
		try {
			const response = await noauthinstance.post("agents/login/", formdata);
			console.log({ response });

			if (response.data && response.data.token) {
				const Token = response.data.token;
				const userRole = response.data.user.role;
				const ID = response.data.user.agent_id;
				const username = response.data.user.name;
				console.log("Token:", Token);
				console.log("User Role:", userRole);
				console.log("ID", ID)

				localStorage.setItem('Token', Token);
				localStorage.setItem('userRole', userRole);
				localStorage.setItem('ID', ID);
				localStorage.setItem('username', username);

				updateToken(Token)

				actions.setTriggerRefresh(prev => prev + 1)
				navigate('/dashboard');
			}
		} catch (error) {
			console.error("Login failed:", error);
			toast.error("Login failed. Please check your credentials and try again.");
		}
		finally {
			setLoading(false);
		}
	};






	return (
		<>
			<div className="app-page-login">
				<div className="app-page-login__wrapper">
					<div className="app-page-login__card">
						<h2>Login</h2>
						<div className="app-page-login__formgroup">
							<div className="app-page-login__field">
								<Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
									<MailOutline sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
									<TextField
										type="email"
										fullWidth
										required
										id="input-email"
										label="Email"
										placeholder="Enter your email"
										variant="standard"
										onChange={(e) => setEmail(e.target.value)}
										error={formSubmitted && !email}
									/>
								</Box>
							</div>
							<div className="app-page-login__field">
								<Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
									<LockOutlined sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
									<TextField
									 type={showPassword ? "text" : "password"}
										fullWidth
										required
										id="input-password"
										label="Password"
										placeholder="Enter your password"
										variant="standard"
										onChange={(e) => setPassword(e.target.value)}
										error={formSubmitted && !password}
										InputProps={{
											endAdornment: (
											  <InputAdornment position="end">
												<IconButton
												  edge="end"
												  onClick={() => setShowPassword((prev) => !prev)}
												>
												 {showPassword ? <Visibility /> : <VisibilityOff />}

												</IconButton>
											  </InputAdornment>
											),
										  }}
									/>
								</Box>
							</div>
							<div className="app-page-login__forgotpassword">
								<Link to="/forgotpassword">
									<Button style={{ padding: 0 }}>
										Forgot Password?
									</Button>
								</Link>
							</div>
							<div className="app-page-login__button">
								<Button
									color="primary"
									variant="contained"
									onClick={handleLogin}
									disabled={loading}
								>
									{loading ? <Spinner /> : <LoginOutlined />}Login
								</Button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<ToastContainer position="top-right" />
		</>
	);
}

export default Login;

